import type { HistoryOptions } from "@bloomberg/octagon-client";
import { type ChartDateRange, Periodicity } from "@bloomberg/octagon-shared";
import { marketDataClient } from "~config/octagon-client";
import { HistoryChartData } from "~types/types";
import { getChartDates } from "~utils/ticker-chart";

const mc = marketDataClient.getInstance();

function getDefaultPeriodicity(chartDateRange: ChartDateRange): Periodicity {
  switch (chartDateRange) {
    case "5Y":
      return Periodicity.Weekly;
    default:
      return Periodicity.Daily;
  }
}

export const fetchHistoryChartData = async (
  tickers: Array<string>,
  chartDateRange: ChartDateRange,
  fields = "PX_LAST",
  referenceFields?: string,
  periodicity?: Periodicity
): Promise<HistoryChartData[]> => {
  try {
    const { startDate, endDate } = getChartDates(chartDateRange);

    const resolvedPeriodicity = (periodicity ??
      getDefaultPeriodicity(
        chartDateRange
      )) as unknown as HistoryOptions["periodicity"];

    const historyResponse = await mc.getHistory({
      securities: tickers.join(","),
      startDate,
      endDate,
      periodicity: resolvedPeriodicity,
      fields,
      referenceFields,
    });

    return historyResponse as unknown as HistoryChartData[];
  } catch (error) {
    window?.newrelic.noticeError?.(error, {
      context: "fetchHistoryChartData",
      tickers,
    });

    throw new Error(
      `Failed to fetch fetchHistoryChartData for ${tickers.join(
        ", "
      )} (${chartDateRange})`
    );
  }
};
